import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Ellipsis, Tabs } from 'antd-mobile';
import isEmpty from 'lodash/isEmpty';

import './index.less';
import { getCDNAssets } from '@/utils';
import { fetchProtocol, getCommonConfNoticesReqConfig } from '@/apis/my';
import type { ProtocolItem } from '@/apis/my';
import useAppTitle from '@/hooks/useTitle';
import { useResource } from '@axios-use/react';
import useQuery from '@/hooks/useQuery';

const ProtocolPage = () => {
  const [data, setData] = useState<ProtocolItem[]>([]);
  const getProtocol = useCallback(() => {
    fetchProtocol()
      .then((res) => {
        if (res) {
          setData(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handletoH5Page = useCallback((url: string) => {
    window.location.href = url;
  }, []);
  useEffect(() => {
    getProtocol();
  }, []);
  return (
    <div>
      {/* <Header title="条款与规则" /> */}
      <div className={'protocol-view'}>
        {data &&
          data.map((item, index) => {
            return (
              <div
                className={'item-view'}
                key={index}
                onClick={() => {
                  handletoH5Page(item?.url);
                }}>
                {index !== 0 && <div className={'item-divider'}></div>}
                <div className={'item-content'}>
                  <span className={'item-title'}>{item?.title}</span>
                  <img className={'item-arrow'} src={getCDNAssets('right_arrow.png')} />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const EMPTY_NOTICES_IMG = 'https://img.mcd.cn/gallery/b21f44cb12762d43.png';

const NoticeList = () => {
  const [res] = useResource(getCommonConfNoticesReqConfig, []);

  const empty = useMemo(() => res.isLoading === false && isEmpty(res.data), [res]);

  if (empty) {
    return (
      <div className="protocol-notice-list_empty">
        <img className={'item-arrow'} src={EMPTY_NOTICES_IMG} />
        <p>暂无公告</p>
      </div>
    );
  }

  return (
    <div className="protocol-notice-list">
      {res.data?.map(
        (i, index) =>
          i.url && (
            <a className="protocol-notice-list_item" href={i.url} key={`${i.title}${index}`}>
              <Ellipsis className="protocol-notice-list_item_title" content={i.title} />
              {i.date && <div className="protocol-notice-list_item_subtitle">{i.date}</div>}
              <img className="protocol-notice-list_item_arrow" src={getCDNAssets('right_arrow.png')} />
            </a>
          ),
      )}
    </div>
  );
};

enum EProtocolTabType {
  TERMS = 'TERMS',
  NOTICE = 'NOTICE',
}

type NewProtocolUrlQuery = {
  type?: string;
};

const NewProtocolPage = () => {
  useAppTitle({
    title: '条款与规则',
    navBackgroundColor: 'FFFFFFFF',
    appletStyle: 'black',
    backBtnVisible: '1',
    appletTitleBarVisible: '1',
  });
  const query = useQuery<NewProtocolUrlQuery>({ type: EProtocolTabType.TERMS });
  const tabType = query?.type;
  const navigate = useNavigate();

  const onTabChange = useCallback(
    (type: string) => {
      navigate(
        {
          pathname: location.pathname,
          search: new URLSearchParams({ type }).toString(),
        },
        { replace: true },
      );
    },
    [navigate],
  );

  return (
    <div className="new-protocol-page">
      <Tabs activeKey={tabType} onChange={onTabChange}>
        <Tabs.Tab title="条款规则" key={EProtocolTabType.TERMS} destroyOnClose />
        <Tabs.Tab title="公告" key={EProtocolTabType.NOTICE} destroyOnClose />
      </Tabs>
      <div className="new-protocol-page_content">
        {tabType === EProtocolTabType.TERMS && <ProtocolPage />}
        {tabType === EProtocolTabType.NOTICE && <NoticeList />}
      </div>
    </div>
  );
};
export default NewProtocolPage;
